'use client';

import React from 'react';
import Image from 'next/image';
import { Box, Typography, IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';
import { isEmpty } from 'lodash';

import useIsDarkMode from '@/app/lib/hooks/useIsDarkMode';

const Title = styled(Typography)(({ theme }) => ({
	fontWeight: 800,
	fontSize: `${theme.typography.pxToRem(36)} !important`,
	color: theme.palette.text.primary,
	marginBottom: theme.spacing(1)
}));

const Subtitle = styled(Typography)(({ theme }) => ({
	fontSize: theme.typography.pxToRem(24),
	color: theme.palette.text.primary
}));

const StyledIconButton = styled(IconButton)(({ theme }) => ({
	backgroundColor: theme.palette.vMaroon.main,
	'&:hover': {
		backgroundColor: theme.palette.vMaroon.light
	}
}));

const CompanyCard = ({ socialMediaLinks, companyInformation }) => {
	const isDarkMode = useIsDarkMode();

	const CardContainer = styled(Box)(({ theme }) => ({
		height: '100%',
		backgroundColor: '#ADADAD60',
		backdropFilter: 'blur(1.5px)',
		padding: theme.spacing(4),
		border: isDarkMode ? `1px solid ${theme.palette.vGray.main}` : `1px solid ${theme.palette.vGray.dark}`,
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
		gap: theme.spacing(6),
		[theme.breakpoints.up('md')]: {
			padding: theme.spacing(6)
		}
	}));

	return (
		<CardContainer>
			<Box>
				<Title variant="h3">Contact Information</Title>
				<Subtitle></Subtitle>
			</Box>
			<Box component="address">
				{!isEmpty(companyInformation) &&
					companyInformation.map(info => (
						<Box
							key={info.Id}
							sx={{
								mb: 2,
								display: 'flex',
								alignItems: 'center',
								gap: 4,
								'& a:hover': {
									textDecoration: 'underline'
								},
								'& svg': {
									width: '35px',
									height: '35px'
								}
							}}>
							{info.Icon}
							{info.Type === 'Link' ? (
								<a href={info.Link}>
									<Typography sx={{ wordBreak: 'break-all' }}>{info.Value}</Typography>
								</a>
							) : info.Type === 'Address' ? (
								<a href={info.Link} target="_blank">
									<Typography>{info.Value}</Typography>
								</a>
							) : (
								<Typography>{info.Value}</Typography>
							)}
						</Box>
					))}
			</Box>
			<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: 2 }}>
				{!isEmpty(socialMediaLinks) &&
					socialMediaLinks.map(socialMediaLink => (
						<a
							key={socialMediaLink.Id}
							href={socialMediaLink.Url}
							target="_blank"
							rel="noopener norefferer">
							<StyledIconButton>
								<Image src={socialMediaLink.Icon} width={32} height={32} alt={socialMediaLink.Name} />
							</StyledIconButton>
						</a>
					))}
			</Box>
		</CardContainer>
	);
};

export default CompanyCard;
